var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrafthuntLogo = function SvgCrafthuntLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crafthunt_logo_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crafthunt_logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.69 152.32H86.4l84.29-91.86V-1L26 152.31v43.77h144.69v-43.76Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crafthunt_logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h196v196H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "crafthunt_logo_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(26 -1)",
    d: "M0 0h144.69v197.08H0z"
  })))));
};
export default SvgCrafthuntLogo;